import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { IconComponent } from './icon.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [IconComponent],
  imports: [MatIconModule, CommonModule, HttpClientModule],
  exports: [IconComponent],
})
export class IconsModule {}
